import { render, staticRenderFns } from "./orders-page-general-list.vue?vue&type=template&id=12774a63&scoped=true"
import script from "./orders-page-general-list.vue?vue&type=script&lang=js"
export * from "./orders-page-general-list.vue?vue&type=script&lang=js"
import style0 from "./orders-page-general-list.vue?vue&type=style&index=0&id=12774a63&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12774a63",
  null
  
)

export default component.exports